import { cacheKeys } from "@constants/cache-keys";
import type { QueryClient } from "@tanstack/react-query";

const userDataCacheKeys: string[] = [
	cacheKeys.home,
	cacheKeys.progress,
	cacheKeys.leaderboard,
	cacheKeys.userLeaderboard,
	cacheKeys.exams,
	cacheKeys.examsCount,
	cacheKeys.examDetails,
	cacheKeys.itemsCount,
	cacheKeys.userSessions,
	cacheKeys.practiceTest,
	cacheKeys.studypack,
	cacheKeys.cumulativeContentsDist,
	cacheKeys.insights,
	cacheKeys.dashboard,
	cacheKeys.sessionConfig,
	cacheKeys.activeAccessCodes,
];

/**
 * Invalidates user/exam-scoped data queries (progress, leaderboards, exams,
 * session-derived caches) while leaving static caches (product config,
 * avatars, version checks) untouched. Use instead of an unfiltered
 * `queryClient.invalidateQueries()`.
 */
export const invalidateUserDataQueries = (queryClient: QueryClient) => {
	queryClient.invalidateQueries({
		predicate: ({ queryKey }) =>
			queryKey.some(
				(part) => typeof part === "string" && userDataCacheKeys.includes(part),
			),
	});
};
